import './index.scss';

const Error404 = () => {
  return (
    <div>
      <div className="error404">
        <img
          src={require('@/images/common/network.png')}
          alt=""
          className="error404__icon"
        />
        <p className="error404__text">页面没找到～</p>
      </div>
    </div>
  );
};
export default Error404;
